// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3934) return "static/chunks/05e3bf0d-b09f4cbc16ab7cef.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "f468f03cb66ba436" + ".js";
};